import { LocaleContext } from 'containers/App/LocaleContext';
import { type FC, type ReactElement, useMemo } from 'react';
import { type AppTranslations, translations } from 'translations/translations';

interface Props {
  children: ReactElement;
}

export const Locale: FC<Props> = (props) => {
  const msg: AppTranslations = useMemo(() => translations('en'), []);
  return (
    <LocaleContext.Provider value={msg}>
      {props.children}
    </LocaleContext.Provider>
  );
};
